import auth from '@/auth/authService';

export default {
  isUserLoggedIn: () => {
    return localStorage.getItem('userInfo') && auth.isAuthenticated;
  },
};
